import { render, staticRenderFns } from "./CustomEditor.vue?vue&type=template&id=32c64c91&scoped=true&"
import script from "./CustomEditor.vue?vue&type=script&lang=js&"
export * from "./CustomEditor.vue?vue&type=script&lang=js&"
import style0 from "./CustomEditor.vue?vue&type=style&index=0&id=32c64c91&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c64c91",
  null
  
)

export default component.exports